import { render, staticRenderFns } from "./LeftSideMenuLv2Item.vue?vue&type=template&id=7da235c0&scoped=true&"
import script from "./LeftSideMenuLv2Item.vue?vue&type=script&lang=js&"
export * from "./LeftSideMenuLv2Item.vue?vue&type=script&lang=js&"
import style0 from "./LeftSideMenuLv2Item.vue?vue&type=style&index=0&id=7da235c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7da235c0",
  null
  
)

export default component.exports